import moment from 'moment';
import { MomentRangeValue } from '../../../types';

export const isMomentRange = (value: unknown): value is MomentRangeValue => {
	return Array.isArray(value) && value.length >= 2 && value.slice(0, 2).every(obj => obj instanceof moment);
};
